import React, { HTMLAttributes } from "react";
import classes from "./index.module.css";
import { ActionIcon as MantineActionIcon } from "@mantine/core";
import { ActionIconProps as MantineActionIconProps } from "@mantine/core";

export type ActionIconProps = MantineActionIconProps & HTMLAttributes<HTMLSpanElement>;

const ActionIcon = (props: ActionIconProps) => {
  return <MantineActionIcon classNames={classes} {...props} />;
};

export default ActionIcon;
